import { render, staticRenderFns } from "./SearchBoxPortador.vue?vue&type=template&id=0fcd0792&scoped=true"
import script from "./SearchBoxPortador.vue?vue&type=script&lang=js"
export * from "./SearchBoxPortador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../paylogos-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcd0792",
  null
  
)

export default component.exports